import { FC, PropsWithChildren } from 'react';

interface CommonInformationProps {
  header: string;
}

export const CommonInformationBoard: FC<PropsWithChildren<CommonInformationProps>> = ({ header, children }) => {
  return (
    <div className="flex flex-col w-full rounded-lg gap-5 p-6 bg-base-80">
      <h2 className="text-hm mb-[-4px]">{header}</h2>
      {children}
    </div>
  );
};
